import React, { useEffect } from 'react';
import { TimelineMax, Linear } from 'gsap';

import { FEATURE_FLAGS } from 'config';
import Commodity from 'components/commodity';
import { useMarketData } from 'context/market';

import {
  liveTicker,
  liveTickerLabel,
  liveTickerContainer,
} from './scss/LiveTicker.module.scss';

const LiveTicker = () => {
  const { marketIndices } = useMarketData();

  useEffect(() => {
    if (!FEATURE_FLAGS.ANIMATE_LIVE_TICKER) {
      return;
    }

    const timeline = new TimelineMax({ paused: true });
    const ticker = document.getElementById('ticker');
    const marketFeed = document.querySelector('.marketFeed');

    ticker.addEventListener('mouseenter', () => timeline.pause());
    ticker.addEventListener('mouseleave', () => timeline.play());
    timeline
      .to('.marketFeed', 30, {
        x: -marketFeed.offsetWidth - 108,
        repeat: -1,
        ease: Linear.easeNone,
      })
      .play();
  }, []);
  return (
    <div className={liveTickerContainer}>
      <div className={liveTickerLabel}>
        Live market <br />
        prices
      </div>
      <div className={liveTicker} id="ticker">
        <ul className="marketFeed">
          {marketIndices.map((marketIndex, index) => {
            return (
              <li key={`main-${index}`}>
                <Commodity item={marketIndex} />
              </li>
            );
          })}
        </ul>
        <ul className="marketFeed">
          {marketIndices.map((marketIndex, index) => {
            return (
              <li key={`clone-a-${index}`}>
                <Commodity item={marketIndex} />
              </li>
            );
          })}
        </ul>
        <ul className="marketFeed">
          {marketIndices.map((marketIndex, index) => {
            return (
              <li key={`clones-b-${index}`}>
                <Commodity item={marketIndex} />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default LiveTicker;
